// import { useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useTranslation } from 'react-i18next';
// import { Link, useNavigate } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';
// import useGetPurchaseOrdertList from '@hooks/PUR/useGetPurchaseOrderList';
// import NeatixModal from '@components/Modal/NeatixModal';
// import PurchaseRequestList from '../PurchaseRequest/PurchaseRequestList';
// import PurchaseQuotationList from '../Quotation/PurchaseQuotationList';
// import { Card, CardBody } from '@components/card/card';
// import NtxTable from '@components/DataTable/NtxTable';
// import { DeletePurchaseOrder, getPurchaseOrderList } from '@store/purchases/PurchaseOrder/purchaseOrderSlice';
// import { useAppDispatch } from '@store/hooks';
// import confirmAction from '@components/Shared/Alert/confirmAction';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { Can } from '@Permisstions/Can';

// const Index = () => {
//   const [showPurchaseRequest, setShowPurchaseRequest] = useState(false);
//   const [showPurchaseQuotation, setShowPurchaseQuotation] = useState(false);

//   const { t, i18n } = useTranslation();
//   const Navigate = useNavigate();
//   const { PurchaseOrderList, loading, error } = useGetPurchaseOrdertList();
//   const dispatch = useAppDispatch();

//   const handleDeletePurchaseOrder = async (id: string) => {
//     const isConfirmed = await confirmAction('هل أنت متأكد من حذف أمر الشراء؟');

//     if (!isConfirmed) return;

//     try {
//       const result = await dispatch(DeletePurchaseOrder(id)).unwrap();
//       if (result?.succeeded) {
//         CustomAlert({ action: 'Delete', msg: t('تم حذف أمر الشراء بنجاح') });
//         dispatch(getPurchaseOrderList());
//       }
//     } catch (e: any) {
//       CustomAlert({ action: 'Error', msg: e?.message || t('فشل حذف أمر الشراء') });
//     }
//   };

//   const columns = [
//     { title: t('Number'), key: 'code' },
//     { title: t('Date'), key: 'date' },
//     { title: t('Supplier'), key: 'suplere' },
//     { title: t('Branch'), key: 'branch' },
//     { title: t('Amount'), key: 'amount' },
//     { title: t('Status'), key: 'status' },
//     { title: t('type'), key: 'type' },
//     { title: t(''), key: 'action', className: 'text-end' }
//   ];

//   const tableData = PurchaseOrderList?.slice()
//     ?.sort((a, b) => b?.no - a?.no)
//     ?.map(item => {
//       let rowClass;
//       const bothReceived = item.inventoryFlag && item.noneInventoryFlag;

//       return {
//         code: item.code,
//         date: item.transactionDate?.toString()?.split('T')[0],
//         suplere: i18n.language === 'en' ? item.peopleName : item.peopleName2,
//         branch: i18n.language === 'en' ? item.organizationName : item.organizationName2,
//         amount: item.netAmount,
//         status: bothReceived ? (
//           // ✅ حالة الاستلام بالكامل
//           <span className='badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//             <i className='fa fa-check-circle fs-15px fa-fw me-5px'></i>
//             {t('تم الاستلام')}
//           </span>
//         ) : item.inventoryFlag === false ? (
//           <span className='badge border border-danger text-danger px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//             <i className={`fa fa-clock fs-15px fa-fw me-5px`}></i>
//             {t(' مخزني: لم يتم استلامه')}
//           </span>
//         ) : item.noneInventoryFlag === false ? (
//           <span className='badge border border-danger text-danger px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//             <i className={`fa fa-clock fs-15px fa-fw me-5px`}></i>
//             {t(' غير مخزني : لم يتم استلامه')}
//           </span>
//         ) : (
//           ''
//         ),
//         type:
//           item.isMultiInventoryFlag === true ? (
//             <span className='badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//               {t('متعدد')}
//             </span>
//           ) : (
//             <span className='badge border border-danger text-danger px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//               {t('مخزن واحد')}
//             </span>
//           ),
//         action: (
//           <>
//             <div className='d-flex '>
//               <button
//                 type='button'
//                 className='btn btn-sm btn-outline-danger mx-1'
//                 onClick={() => handleDeletePurchaseOrder(item.id)}
//               >
//                 <i className='fas fa-trash fa-lg'></i>
//               </button>
//               <Can permission={'PURViewPurchaseOrderDetails'}>
//                 <button
//                   type='button'
//                   className='btn btn-sm btn-outline-theme mx-1'
//                   onClick={() =>
//                     item.isMultiInventoryFlag === true
//                       ? Navigate(`${item.id}/UpdatePurchaseOrder/multi`)
//                       : Navigate(`${item.id}/UpdatePurchaseOrder`)
//                   }
//                 >
//                   <i className='fas fa-info-circle fa-lg'></i>
//                 </button>
//               </Can>
//             </div>
//           </>
//         )
//       };
//     });

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//               link: ':moduleHome'
//             },
//             {
//               name: 'أوامر الشــراء',
//               link: null
//             }
//           ]}
//           PageName='أوامر الشــراء'
//         />
//         <div className='ms-auto'>
//           <Can permission={'PURAddPurchaseOrder'}>
//             <div className='btn-group' role='group' style={{ direction: 'ltr' }}>
//               <button
//                 type='button'
//                 className='btn btn-theme dropdown-toggle'
//                 data-bs-toggle='dropdown'
//                 aria-expanded='false'
//               >
//                 {t('أمر شراء جديد')}
//               </button>
//               <ul className='dropdown-menu text-center '>
//                 <li>
//                   <Link className='dropdown-item text-start d-flex justify-content-end' to='AddPurchaseOrder/not_multi'>
//                     جديد
//                     <i className='fa fa-file-invoice fa-fw ms-2 text-theme'></i>
//                   </Link>
//                 </li>
//                 <hr className='m-0' />

//                 <li>
//                   <Link
//                     className='dropdown-item text-start d-flex justify-content-end'
//                     to=''
//                     onClick={() => setShowPurchaseRequest(true)}
//                   >
//                     من طلب شراء
//                     <i className='fa fa-file-import fa-fw ms-2 text-theme'></i>
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     className='dropdown-item text-start d-flex justify-content-end'
//                     to=''
//                     onClick={() => setShowPurchaseQuotation(true)}
//                   >
//                     من عرض سعر
//                     <i className='fa fa-file-signature fa-fw ms-2 text-theme'></i>
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//           </Can>
//         </div>
//       </div>
//       <Card>
//         <Loading loading={loading} error={error}>
//           <CardBody>
//             <NtxTable
//               data={tableData || []}
//               columns={columns}
//               dataPerPage={10}
//               theadClass=''
//               tableClass='table text-nowrap table-hover'
//               enableSearch
//               showRecordsSelector
//             />
//           </CardBody>
//         </Loading>
//       </Card>

//       <NeatixModal
//         show={showPurchaseRequest}
//         setShow={setShowPurchaseRequest}
//         bodyClassName='p-0'
//         size='lg'
//         showHeader={false}
//       >
//         <PurchaseRequestList Route='PurchaseOrder' />
//       </NeatixModal>

//       <NeatixModal
//         show={showPurchaseQuotation}
//         setShow={setShowPurchaseQuotation}
//         bodyClassName='p-0'
//         size='lg'
//         showHeader={false}
//       >
//         <PurchaseQuotationList Route='PurchaseOrder' />
//       </NeatixModal>
//     </>
//   );
// };

// export default Index;

// import { useEffect, useMemo, useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import { Link, useNavigate } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';
// import NeatixModal from '@components/Modal/NeatixModal';

// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { getPagedData, setEndpoint, setFilters } from '@store/DynamicFilter/dynamicTableSlice';

// import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
// import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';

// import Select from 'react-select';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

// import PurchaseRequestList from '../PurchaseRequest/PurchaseRequestList';
// import PurchaseQuotationList from '../Quotation/PurchaseQuotationList';

// import confirmAction from '@components/Shared/Alert/confirmAction';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { DeletePurchaseOrder } from '@store/purchases/PurchaseOrder/purchaseOrderSlice';

// import { Can } from '@Permisstions/Can';

// const TABLE_KEY = 'PurchaseOrders_Index';

// const Index = () => {
//   const [showPurchaseRequest, setShowPurchaseRequest] = useState(false);
//   const [showPurchaseQuotation, setShowPurchaseQuotation] = useState(false);
//   const [showFilters, setShowFilters] = useState(false);

//   // ✅ فلاتر أعلى الصفحة
//   const [supplierFilter, setSupplierFilter] = useState<any>(null);
//   const [organizationFilter, setOrganizationFilter] = useState<any>(null);
//   const [dateFrom, setDateFrom] = useState('');
//   const [dateTo, setDateTo] = useState('');
//   const [searchFilter, setSearchFilter] = useState('');

//   const [activeFiltersCount, setActiveFiltersCount] = useState(0);

//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();

//   const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
//   const { OptionSuppliers } = useGetSuppliersList();

//   const dispatch = useAppDispatch();
//   const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
//   const data = tableState?.data ?? [];
//   const loading = tableState?.loading ?? false;
//   const error = tableState?.error ?? null;
//   const filters = tableState?.filters ?? [];

//   useEffect(() => {
//     dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'PurchaseOrder/GetList_paged' }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   }, [dispatch]);

//   useEffect(() => {
//     setActiveFiltersCount(filters.length);
//   }, [filters]);

//   // ✅ (اختياري ومفيد) إعادة تعبئة فلاتر أعلى الصفحة من الـ store عند الرجوع للشاشة
//   useEffect(() => {
//     if (!filters?.length) return;

//     const findOpt = (opts: any[], v: any) => opts?.find(o => o?.value === v) ?? null;

//     const sup = filters.find((f: any) => f.field === 'peopleId' && f.operator === 0);
//     const org = filters.find((f: any) => f.field === 'organizationId' && f.operator === 0);

//     const from = filters.find((f: any) => f.field === 'transactionDate' && f.operator === 3);
//     const to = filters.find((f: any) => f.field === 'transactionDate' && f.operator === 5);

//     const code = filters.find((f: any) => f.field === 'code' && f.operator === 7);

//     if (sup?.value && OptionSuppliers?.length) setSupplierFilter(findOpt(OptionSuppliers, sup.value));
//     if (org?.value && OperatingUnitOptions?.length) setOrganizationFilter(findOpt(OperatingUnitOptions, org.value));

//     if (from?.value) setDateFrom(String(from.value).slice(0, 10));
//     if (to?.value) setDateTo(String(to.value).slice(0, 10));

//     if (code?.value) setSearchFilter(String(code.value));
//   }, [filters, OptionSuppliers, OperatingUnitOptions]);

//   const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

//   const applyFilters = () => {
//     const newFilters: any[] = [];

//     if (supplierFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'peopleId',
//         operator: 0, // OpEquals
//         value: supplierFilter.value
//       });
//     }

//     if (organizationFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'organizationId',
//         operator: 0, // OpEquals
//         value: organizationFilter.value
//       });
//     }

//     if (dateFrom) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'transactionDate',
//         operator: 3, // OpGreaterOrEqual
//         value: dateFrom
//       });
//     }

//     if (dateTo) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'transactionDate',
//         operator: 5, // OpLessOrEqual
//         value: dateTo
//       });
//     }

//     if (searchFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'code',
//         operator: 7, // OpContains
//         value: searchFilter
//       });
//     }

//     dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   };

//   const clearFilters = () => {
//     setSupplierFilter(null);
//     setOrganizationFilter(null);
//     setDateFrom('');
//     setDateTo('');
//     setSearchFilter('');

//     dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   };

//   const handleDeletePurchaseOrder = async (id: string) => {
//     const isConfirmed = await confirmAction(t('هل أنت متأكد من حذف أمر الشراء؟'));
//     if (!isConfirmed) return;

//     try {
//       const result = await dispatch(DeletePurchaseOrder(id)).unwrap();
//       if (result?.succeeded) {
//         CustomAlert({ action: 'Delete', msg: t('تم حذف أمر الشراء بنجاح') });
//         dispatch(getPagedData({ tableKey: TABLE_KEY }));
//       }
//     } catch (e: any) {
//       CustomAlert({ action: 'Error', msg: e?.message || t('فشل حذف أمر الشراء') });
//     }
//   };

//   const formatAmount = (amount: number) =>
//     new Intl.NumberFormat(i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount || 0);

//   const getReceiveStatusBadge = (item: any) => {
//     const bothReceived = item.inventoryFlag && item.noneInventoryFlag;

//     if (bothReceived) {
//       return (
//         <span className='badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//           <i className='fa fa-check-circle fs-15px fa-fw me-5px'></i>
//           {t('تم الاستلام')}
//         </span>
//       );
//     }

//     if (item.inventoryFlag === false) {
//       return (
//         <span className='badge border border-danger text-danger px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//           <i className='fa fa-clock fs-15px fa-fw me-5px'></i>
//           {t(' مخزني: لم يتم استلامه')}
//         </span>
//       );
//     }

//     if (item.noneInventoryFlag === false) {
//       return (
//         <span className='badge border border-danger text-danger px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//           <i className='fa fa-clock fs-15px fa-fw me-5px'></i>
//           {t(' غير مخزني : لم يتم استلامه')}
//         </span>
//       );
//     }

//     return <span className='text-muted'>-</span>;
//   };

//   const getTypeBadge = (isMulti: boolean) =>
//     isMulti ? (
//       <span className='badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//         {t('متعدد')}
//       </span>
//     ) : (
//       <span className='badge border border-danger text-danger px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
//         {t('مخزن واحد')}
//       </span>
//     );

//   const fields: any = useMemo(
//     () => [
//       { name: 'code', label: t('Number'), type: 'string' },
//       { name: 'transactionDate', label: t('Date'), type: 'date' },
//       { name: 'peopleId', label: t('Supplier'), type: 'options', options: OptionSuppliers },
//       { name: 'organizationId', label: t('Branch'), type: 'options', options: OperatingUnitOptions },
//       {
//         name: 'isMultiInventoryFlag',
//         label: t('type'),
//         type: 'options',
//         options: [
//           { value: true, label: t('متعدد') },
//           { value: false, label: t('مخزن واحد') }
//         ]
//       }
//     ],
//     [t, OptionSuppliers, OperatingUnitOptions]
//   );

//   const breadcrumbList = [
//     { name: t('Home'), link: ':moduleHome' },
//     { name: t('أوامر الشــراء'), link: null }
//   ];

//   const displayData = data;

//   return (
//     <>
//       <div className='d-flex flex-wrap align-items-center gap-2'>
//         <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('أوامر الشــراء')} />

//         <div className='ms-auto'>
//           <Can permission={'PURAddPurchaseOrder'}>
//             <div className='btn-group' role='group' style={{ direction: 'ltr' }}>
//               <button type='button' className='btn btn-theme dropdown-toggle' data-bs-toggle='dropdown' aria-expanded='false'>
//                 {t('أمر شراء جديد')}
//               </button>
//               <ul className='dropdown-menu text-center'>
//                 <li>
//                   <Link className='dropdown-item text-start d-flex justify-content-end' to='AddPurchaseOrder/not_multi'>
//                     {t('جديد')}
//                     <i className='fa fa-file-invoice fa-fw ms-2 text-theme'></i>
//                   </Link>
//                 </li>
//                 <hr className='m-0' />
//                 <li>
//                   <Link
//                     className='dropdown-item text-start d-flex justify-content-end'
//                     to=''
//                     onClick={e => {
//                       e.preventDefault();
//                       setShowPurchaseRequest(true);
//                     }}
//                   >
//                     {t('من طلب شراء')}
//                     <i className='fa fa-file-import fa-fw ms-2 text-theme'></i>
//                   </Link>
//                 </li>
//                 <li>
//                   <Link
//                     className='dropdown-item text-start d-flex justify-content-end'
//                     to=''
//                     onClick={e => {
//                       e.preventDefault();
//                       setShowPurchaseQuotation(true);
//                     }}
//                   >
//                     {t('من عرض سعر')}
//                     <i className='fa fa-file-signature fa-fw ms-2 text-theme'></i>
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//           </Can>
//         </div>
//       </div>

//       {/* ✅ شريط الفلاتر مثل PurchaseRequests */}
//       <Card className='mb-3 shadow bg-body1'>
//         <CardHeader>
//           <div className='row g-2'>
//             {/* وحدة التشغيل */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-building'></i>
//                 </span>
//                 <Select
//                   value={organizationFilter}
//                   onChange={setOrganizationFilter}
//                   options={OperatingUnitOptions}
//                   placeholder={t('اختر وحدة التشغيـل')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//                 />
//               </div>
//             </div>

//             {/* المورد */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-truck'></i>
//                 </span>
//                 <Select
//                   value={supplierFilter}
//                   onChange={setSupplierFilter}
//                   options={OptionSuppliers}
//                   placeholder={t('اختر مورد')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                   menuPortalTarget={document.body}
//                   styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//                 />
//               </div>
//             </div>

//             {/* التاريخ من وإلى */}
//             <div className='col-lg-4'>
//               <div className='input-group'>
//                 <span className='input-group-text'>
//                   <i className='fas fa-calendar-alt text-muted'></i>
//                 </span>
//                 <input
//                   type='date'
//                   className='form-control border-start-0'
//                   value={dateFrom}
//                   onChange={e => setDateFrom(e.target.value)}
//                   placeholder={t('From')}
//                 />
//                 <span className='input-group-text'>-</span>
//                 <input type='date' className='form-control' value={dateTo} onChange={e => setDateTo(e.target.value)} placeholder={t('To')} />
//               </div>
//             </div>

//             {/* أزرار */}
//             <div className='col-lg-2 text-end'>
//               <button
//                 className='btn btn-outline-secondary me-2'
//                 type='button'
//                 onClick={clearFilters}
//                 title={t('ClearFilters')}
//                 disabled={activeFiltersCount === 0}
//               >
//                 <i className='fas fa-times fa-fw'></i>
//               </button>

//               <button
//                 className='btn btn-theme me-2'
//                 type='button'
//                 onClick={applyFilters}
//                 title={t('ApplyFilters')}
//                 disabled={!supplierFilter && !organizationFilter && !dateFrom && !dateTo && !searchFilter}
//               >
//                 <i className='fas fa-filter fa-fw'></i>
//               </button>

//               <button className='btn btn-outline-theme w-md-auto' onClick={() => setShowFilters(true)} title={t('AdvancedFilters')}>
//                 <i className='fas fa-sliders-h fa-fw'></i>
//               </button>
//             </div>

//             {/* بحث (اختياري) */}
//             <div className='col-12'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-search'></i>
//                 </span>
//                 <input
//                   className='form-control'
//                   value={searchFilter}
//                   onChange={e => setSearchFilter(e.target.value)}
//                   placeholder={t('بحث برقم أمر الشراء (PO...)')}
//                 />
//               </div>
//             </div>
//           </div>
//         </CardHeader>
//       </Card>

//       {/* ✅ الجدول */}
//       <Card className='mb-4'>
//         <Loading loading={loading} error={error}>
//           <CardBody className='p-0'>
//             <div className='table-responsive'>
//               <table className='table table-hover mb-0'>
//                 <thead className='bg-theme bg-opacity-25 fw-bold'>
//                   <tr>
//                     <th className='small'>{t('Number')}</th>
//                     <th className='small'>{t('Date')}</th>
//                     <th className='small'>{t('Supplier')}</th>
//                     <th className='small'>{t('Branch')}</th>
//                     <th className='small'>{t('Amount')}</th>
//                     <th className='small'>{t('Status')}</th>
//                     <th className='small'>{t('type')}</th>
//                     <th className='small text-center'>{t('Actions')}</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {displayData.length > 0 ? (
//                     displayData.map((item: any) => {
//                       const detailsUrl =
//                         item.isMultiInventoryFlag === true ? `${item.id}/UpdatePurchaseOrder/multi` : `${item.id}/UpdatePurchaseOrder`;

//                       return (
//                         <tr key={item.id}>
//                           <td className='align-middle'>
//                             <strong className='text-theme'>{item.code}</strong>
//                             {/* {item.description ? <div className='text-muted small mt-1'>{item.description}</div> : null} */}
//                           </td>

//                           <td className='align-middle'>{String(item.transactionDate || '').split('T')[0]}</td>

//                           <td className='align-middle'>{i18n.language === 'en' ? item.peopleName : item.peopleName2}</td>

//                           <td className='align-middle'>{i18n.language === 'en' ? item.organizationName : item.organizationName2}</td>

//                           <td className='align-middle'>
//                             <span className='fw-bold text-theme'>{formatAmount(item.netAmount)}</span>
//                           </td>

//                           <td className='align-middle'>{getReceiveStatusBadge(item)}</td>

//                           <td className='align-middle'>{getTypeBadge(!!item.isMultiInventoryFlag)}</td>

//                           <td className='align-middle text-end'>
//                             <div className='d-flex justify-content-end gap-2'>
//                               <button
//                                 type='button'
//                                 className='btn btn-sm btn-outline-danger'
//                                 onClick={() => handleDeletePurchaseOrder(item.id)}
//                                 title={t('Delete')}
//                               >
//                                 <i className='fas fa-trash fa-lg'></i>
//                               </button>

//                               <Can permission={'PURViewPurchaseOrderDetails'}>
//                                 <button
//                                   type='button'
//                                   className='btn btn-sm btn-outline-theme'
//                                   onClick={() => navigate(detailsUrl)}
//                                   title={t('ViewDetails')}
//                                 >
//                                   <i className='fas fa-info-circle fa-lg me-2'></i>
//                                   {t('ViewDetails')}
//                                 </button>
//                               </Can>
//                             </div>
//                           </td>
//                         </tr>
//                       );
//                     })
//                   ) : (
//                     <tr>
//                       <td colSpan={8} className='text-center py-4 text-muted'>
//                         <i className='fa fa-inbox fa-2x mb-2'></i>
//                         <br />
//                         {activeFiltersCount > 0 ? t('NoSearchResults') : t('لا توجد أوامر شراء')}
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </CardBody>
//         </Loading>

//         <CardFooter>
//           <div className='text-theme'>
//             <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
//           </div>
//         </CardFooter>
//       </Card>

//       <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />

//       <NeatixModal show={showPurchaseRequest} setShow={setShowPurchaseRequest} bodyClassName='p-0' size='lg' showHeader={false}>
//         <PurchaseRequestList Route='PurchaseOrder' />
//       </NeatixModal>

//       <NeatixModal
//         show={showPurchaseQuotation}
//         setShow={setShowPurchaseQuotation}
//         bodyClassName='p-0'
//         size='lg'
//         showHeader={false}
//       >
//         <PurchaseQuotationList Route='PurchaseOrder' />
//       </NeatixModal>
//     </>
//   );
// };

// export default Index;

import { useEffect, useMemo, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters, setSortOrders } from '@store/DynamicSlice/dynamicTableSlice';

import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';

import Select from 'react-select';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';

import PurchaseRequestList from '../PurchaseRequest/PurchaseRequestList';
import PurchaseQuotationList from '../Quotation/PurchaseQuotationList';

import confirmAction from '@components/Shared/Alert/confirmAction';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { DeletePurchaseOrder } from '@store/purchases/PurchaseOrder/purchaseOrderSlice';

import { Can } from '@Permisstions/Can';

const TABLE_KEY = 'PurchaseOrders_Index';

const Index = () => {
  const [showPurchaseRequest, setShowPurchaseRequest] = useState(false);
  const [showPurchaseQuotation, setShowPurchaseQuotation] = useState(false);
  const [showFilters, setShowFilters] = useState(false);

  // ✅ فلاتر أعلى الصفحة
  const [supplierFilter, setSupplierFilter] = useState<any>(null);
  const [organizationFilter, setOrganizationFilter] = useState<any>(null);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [searchFilter, setSearchFilter] = useState('');

  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [creationDateSort, setCreationDateSort] = useState<any>(null);

  const creationDateSortOptions = useMemo(
    () => [
      { value: 'asc', label: t('تصاعدي (الأقدم أولاً)') },
      { value: 'desc', label: t('تنازلي (الأحدث أولاً)') }
    ],
    [t]
  );

  const {
    OperatingUnitOptions,
    loading: operatingUnitLoading,
    error: operatingUnitError
  } = useGetOperatingUnitWithPermission();
  const { OptionSuppliers, loading: suppliersLoading, error: suppliersError } = useGetSuppliersList();

  const dispatch = useAppDispatch();
  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];

  const sortOrders = tableState?.sortOrders ?? [];

  useEffect(() => {
    setActiveFiltersCount((filters?.length ?? 0) + (sortOrders?.length ?? 0));
  }, [filters, sortOrders]);

  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'PurchaseOrder/GetList_paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch]);

  useEffect(() => {
    setActiveFiltersCount(filters.length);
  }, [filters]);

  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  // const applyFilters = () => {
  //   const newFilters: any[] = [];

  //   if (supplierFilter) {
  //     newFilters.push({
  //       id: generateFilterId(),
  //       field: 'peopleId',
  //       operator: 0, // OpEquals
  //       value: supplierFilter.value
  //     });
  //   }

  //   if (organizationFilter) {
  //     newFilters.push({
  //       id: generateFilterId(),
  //       field: 'organizationId',
  //       operator: 0, // OpEquals
  //       value: organizationFilter.value
  //     });
  //   }

  //   if (dateFrom) {
  //     newFilters.push({
  //       id: generateFilterId(),
  //       field: 'transactionDate',
  //       operator: 3, // OpGreaterOrEqual
  //       value: dateFrom
  //     });
  //   }

  //   if (dateTo) {
  //     newFilters.push({
  //       id: generateFilterId(),
  //       field: 'transactionDate',
  //       operator: 5, // OpLessOrEqual
  //       value: dateTo
  //     });
  //   }

  //   if (searchFilter) {
  //     newFilters.push({
  //       id: generateFilterId(),
  //       field: 'code',
  //       operator: 7, // OpContains
  //       value: searchFilter
  //     });
  //   }

  //   dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
  //   dispatch(getPagedData({ tableKey: TABLE_KEY }));
  // };

  const applyFilters = () => {
    const newFilters: any[] = [];

    if (supplierFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'peopleId',
        operator: 0,
        value: supplierFilter.value
      });
    }

    if (organizationFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'organizationId',
        operator: 0,
        value: organizationFilter.value
      });
    }

    if (dateFrom) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionDate',
        operator: 3,
        value: dateFrom
      });
    }

    if (dateTo) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionDate',
        operator: 5,
        value: dateTo
      });
    }

    if (searchFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'code',
        operator: 7,
        value: searchFilter
      });
    }

    // ✅ Sort Orders (CreationDate)
    const newSortOrders: any[] = creationDateSort
      ? [{ field: 'CreationDate', descending: creationDateSort.value === 'desc' }]
      : [];

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(setSortOrders({ tableKey: TABLE_KEY, sortOrders: newSortOrders }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // const clearFilters = () => {
  //   setSupplierFilter(null);
  //   setOrganizationFilter(null);
  //   setDateFrom('');
  //   setDateTo('');
  //   setSearchFilter('');

  //   dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
  //   dispatch(getPagedData({ tableKey: TABLE_KEY }));
  // };

  const clearFilters = () => {
    setSupplierFilter(null);
    setOrganizationFilter(null);
    setDateFrom('');
    setDateTo('');
    setSearchFilter('');
    setCreationDateSort(null);

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(setSortOrders({ tableKey: TABLE_KEY, sortOrders: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  const handleDeletePurchaseOrder = async (id: string) => {
    const isConfirmed = await confirmAction(t('هل أنت متأكد من حذف أمر الشراء؟'));
    if (!isConfirmed) return;

    try {
      const result = await dispatch(DeletePurchaseOrder(id)).unwrap();
      if (result?.succeeded) {
        CustomAlert({ action: 'Delete', msg: t('تم حذف أمر الشراء بنجاح') });
        dispatch(getPagedData({ tableKey: TABLE_KEY }));
      }
    } catch (e: any) {
      CustomAlert({ action: 'Error', msg: e?.message || t('فشل حذف أمر الشراء') });
    }
  };

  const formatAmount = (amount: number) =>
    new Intl.NumberFormat(i18n.language, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount || 0);

  const getReceiveStatusBadge = (item: any) => {
    const bothReceived = item.inventoryFlag && item.noneInventoryFlag;

    if (bothReceived) {
      return (
        <span className='badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
          <i className='fa fa-check-circle fs-15px fa-fw me-5px'></i>
          {t('تم الاستلام')}
        </span>
      );
    }

    if (item.inventoryFlag === false) {
      return (
        <span className='badge border border-danger text-danger px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
          <i className='fa fa-clock fs-15px fa-fw me-5px'></i>
          {t(' مخزني: لم يتم استلامه')}
        </span>
      );
    }

    if (item.noneInventoryFlag === false) {
      return (
        <span className='badge border border-danger text-danger px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
          <i className='fa fa-clock fs-15px fa-fw me-5px'></i>
          {t(' غير مخزني : لم يتم استلامه')}
        </span>
      );
    }

    return <span className='text-muted'>-</span>;
  };

  // ✅ النوع: إذا متعدد -> "متعدد" ، غير ذلك -> اسم المخزن + "مخزن واحد"
  const getTypeOrInventoryDisplay = (item: any) => {
    if (item?.isMultiInventoryFlag) {
      return (
        <span className='badge border border-success text-success px-2 pt-5px pb-5px rounded fs-12px d-inline-flex align-items-center'>
          <i className='fa fa-layer-group fs-15px fa-fw me-5px'></i>
          {t('متعدد')}
        </span>
      );
    }

    const invName = i18n.language === 'en' ? item?.inventoryName : item?.inventoryName2;

    return (
      <div className='d-flex flex-column'>
        <span className='fw-bold1 text-theme1'>{invName || '-'}</span>
        {/* <small className='text-muted'>{t('مخزن واحد')}</small> */}
      </div>
    );
  };

  const fields: any = useMemo(
    () => [
      { name: 'no', label: t('التسلسل'), type: 'number' },
      { name: 'code', label: t('Number'), type: 'string' },
      { name: 'transactionDate', label: t('Date'), type: 'date' },
      { name: 'peopleId', label: t('Supplier'), type: 'options', options: OptionSuppliers },
      { name: 'organizationId', label: t('Branch'), type: 'options', options: OperatingUnitOptions },
      { name: 'netAmount', label: t('مبلغ أمر الشراء'), type: 'number' },
      { name: 'CreationDate', label: t('تاريخ إنشاء أمر الشراء'), type: 'number' },
      {
        name: 'isMultiInventoryFlag',
        label: t('type'),
        type: 'options',
        options: [
          { value: true, label: t('متعدد') },
          { value: false, label: t('مخزن واحد') }
        ]
      }
    ],
    [t, OptionSuppliers, OperatingUnitOptions]
  );

  const breadcrumbList = [
    { name: t('Home'), link: ':moduleHome' },
    { name: t('أوامر الشــراء'), link: null }
  ];

  const displayData = data;

  return (
    <>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('أوامر الشــراء')} />

        <div className='ms-auto'>
          <Can permission={'PURAddPurchaseOrder'}>
            <div className='btn-group' role='group' style={{ direction: 'ltr' }}>
              <button
                type='button'
                className='btn btn-theme dropdown-toggle'
                data-bs-toggle='dropdown'
                aria-expanded='false'
              >
                {t('أمر شراء جديد')}
              </button>
              <ul className='dropdown-menu text-center'>
                <li>
                  <Link className='dropdown-item text-start d-flex justify-content-end' to='AddPurchaseOrder/not_multi'>
                    {t('جديد')}
                    <i className='fa fa-file-invoice fa-fw ms-2 text-theme'></i>
                  </Link>
                </li>
                <hr className='m-0' />
                <li>
                  <Link
                    className='dropdown-item text-start d-flex justify-content-end'
                    to=''
                    onClick={e => {
                      e.preventDefault();
                      setShowPurchaseRequest(true);
                    }}
                  >
                    {t('من طلب شراء')}
                    <i className='fa fa-file-import fa-fw ms-2 text-theme'></i>
                  </Link>
                </li>
                <li>
                  <Link
                    className='dropdown-item text-start d-flex justify-content-end'
                    to=''
                    onClick={e => {
                      e.preventDefault();
                      setShowPurchaseQuotation(true);
                    }}
                  >
                    {t('من عرض سعر')}
                    <i className='fa fa-file-signature fa-fw ms-2 text-theme'></i>
                  </Link>
                </li>
              </ul>
            </div>
          </Can>
        </div>
      </div>

      {/* ✅ شريط الفلاتر */}
      <Card className='mb-3 shadow bg-body1'>
        <CardHeader>
          <div className='row g-2'>
            {/* وحدة التشغيل */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-building'></i>
                </span>
                <Select
                  value={organizationFilter}
                  onChange={setOrganizationFilter}
                  options={OperatingUnitOptions}
                  placeholder={t('اختر وحدة التشغيـل')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* المورد */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-truck'></i>
                </span>
                <Select
                  value={supplierFilter}
                  onChange={setSupplierFilter}
                  options={OptionSuppliers}
                  placeholder={t('اختر مورد')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* التاريخ من وإلى */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                  placeholder={t('From')}
                />
                <span className='input-group-text'>-</span>
                <input
                  type='date'
                  className='form-control'
                  value={dateTo}
                  onChange={e => setDateTo(e.target.value)}
                  placeholder={t('To')}
                />
              </div>
            </div>

            {/* أزرار */}
            <div className='col-lg-2 text-end'>
              <button
                className='btn btn-outline-secondary me-2'
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw'></i>
              </button>

              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={
                  !supplierFilter && !organizationFilter && !dateFrom && !dateTo && !searchFilter && !creationDateSort
                }
                // disabled={!supplierFilter && !organizationFilter && !dateFrom && !dateTo && !searchFilter}
              >
                <i className='fas fa-filter fa-fw'></i>
              </button>

              <button
                className='btn btn-outline-theme w-md-auto'
                onClick={() => setShowFilters(true)}
                title={t('AdvancedFilters')}
              >
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div>

            {/* بحث + ترتيب حسب تاريخ الإنشاء */}
            <div className='col-12'>
              <div className='row g-2 align-items-center'>
                {/* عمود البحث */}
                <div className='col-lg-8'>
                  <div className='input-group'>
                    <span className='input-group-text fw-bold'>
                      <i className='fas fa-search'></i>
                    </span>
                    <input
                      className='form-control'
                      value={searchFilter}
                      onChange={e => setSearchFilter(e.target.value)}
                      placeholder={t('بحث برقم أمر الشراء (PO...)')}
                    />
                  </div>
                </div>

                {/* عمود الترتيب */}
                <div className='col-lg-4'>
                  <div className='input-group'>
                    <span className='input-group-text fw-bold'>
                      <i className='fas fa-sort-amount-down'></i>
                    </span>
                    <Select
                      value={creationDateSort}
                      onChange={setCreationDateSort}
                      options={creationDateSortOptions}
                      placeholder={t('ترتيب بتاريخ الإنشاء')}
                      isClearable
                      isSearchable={false}
                      className='flex-grow-1'
                      classNamePrefix='react-select'
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* بحث */}
          </div>
        </CardHeader>
      </Card>

      {/* ✅ الجدول */}
      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          <CardBody className='p-0'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='bg-theme bg-opacity-25 fw-bold'>
                  <tr>
                    <th className='small'>{t('Number')}</th>
                    <th className='small'>{t('Date')}</th>
                    <th className='small'>{t('Supplier')}</th>
                    <th className='small'>{t('Branch')}</th>
                    <th className='small'>{t('المخزن')}</th>
                    <th className='small'>{t('Amount')}</th>
                    <th className='small'>{t('Status')}</th>
                    <th className='small text-center'>{t('Actions')}</th>
                  </tr>
                </thead>

                <tbody>
                  {displayData.length > 0 ? (
                    displayData.map((item: any) => {
                      const detailsUrl =
                        item.isMultiInventoryFlag === true
                          ? `${item.id}/UpdatePurchaseOrder/multi`
                          : `${item.id}/UpdatePurchaseOrder`;

                      return (
                        <tr key={item.id}>
                          <td className='align-middle'>
                            <strong className='text-theme'>{item.code}</strong>
                          </td>

                          <td className='align-middle'>{String(item.transactionDate || '').split('T')[0]}</td>

                          <td className='align-middle'>
                            {i18n.language === 'en' ? item.peopleName : item.peopleName2}
                          </td>

                          <td className='align-middle'>
                            {i18n.language === 'en' ? item.organizationName : item.organizationName2}
                          </td>
                          <td className='align-middle'>{getTypeOrInventoryDisplay(item)}</td>

                          <td className='align-middle'>
                            <span className='fw-bold text-theme'>{formatAmount(item.netAmount)}</span>
                          </td>

                          <td className='align-middle'>{getReceiveStatusBadge(item)}</td>

                          {/* ✅ النوع: متعدد أو اسم المخزن */}

                          {/* <td className='align-middle text-end'>
                            <div className='d-flex justify-content-end gap-2'>
                              <button
                                type='button'
                                className='btn btn-sm btn-outline-danger'
                                onClick={() => handleDeletePurchaseOrder(item.id)}
                                title={t('Delete')}
                              >
                                <i className='fas fa-trash fa-lg'></i>
                              </button>

                              <button
                                type='button'
                                className='btn btn-sm btn-outline-success'
                                title={t('تكرار')}
                                onClick={() => {
                                  const targetType = item.isMultiInventoryFlag === true ? 'multi' : 'not_multi';
                                  navigate(`AddPurchaseOrder/${targetType}?copyFrom=${item.id}`);
                                }}
                              >
                                <i className='fas fa-copy fa-lg'></i>
                              </button>

                              <Can permission={'PURViewPurchaseOrderDetails'}>
                                <button
                                  type='button'
                                  className='btn btn-sm btn-outline-theme'
                                  onClick={() => navigate(detailsUrl)}
                                  title={t('ViewDetails')}
                                >
                                  <i className='fas fa-info-circle fa-lg  '></i>
                                </button>
                              </Can>
                            </div>
                          </td> */}

                          <td className='align-middle text-end'>
                            <div className='d-flex justify-content-end gap-2'>
                              <div className='btn-group'>
                                <Can permission={'PURViewPurchaseOrderDetails'}>
                                  <button
                                    type='button'
                                    className='btn btn-outline-theme me-1'
                                    onClick={() => navigate(detailsUrl)}
                                    title={t('ViewDetails')}
                                  >
                                    {/* <i className='fas fa-info-circle fa-fw me-1'></i> */}
                                    <i className='fas fa-edit fa-fw me-1'></i>

                                    {t('تعديـل')}
                                  </button>
                                </Can>

                                <button
                                  type='button'
                                  className='btn btn-outline-theme dropdown-toggle dropdown-toggle-split px-2'
                                  data-bs-toggle='dropdown'
                                  aria-expanded='false'
                                >
                                  <span className='visually-hidden'>Toggle Dropdown</span>
                                </button>

                                <ul className='dropdown-menu'>
                                  {/* خيار حذف أمر الشراء */}
                                  <li>
                                    <button
                                      className='dropdown-item text-start text-danger'
                                      onClick={() => handleDeletePurchaseOrder(item.id)}
                                    >
                                      <i className='fas fa-trash fa-fw me-2'></i>
                                      {t('Delete')}
                                    </button>
                                  </li>

                                  {/* خيار التكرار */}
                                  <li>
                                    <button
                                      className='dropdown-item text-start'
                                      onClick={() => {
                                        const targetType = item.isMultiInventoryFlag === true ? 'multi' : 'not_multi';
                                        navigate(`AddPurchaseOrder/${targetType}?copyFrom=${item.id}`);
                                      }}
                                    >
                                      <i className='fas fa-copy fa-fw me-2'></i>
                                      {/* {t('تكرار')} */}
                                      {t('إنشاء نسخة')}
                                    </button>
                                  </li>

                                  {/* يمكن إضافة المزيد من الخيارات هنا */}
                                  {/* 
        <li>
          <hr className='dropdown-divider' />
        </li>
        <li>
          <button className='dropdown-item text-start'>
            <i className='fas fa-print fa-fw me-2'></i>
            {t('طباعة')}
          </button>
        </li>
        */}
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={8} className='text-center py-4 text-muted'>
                        <i className='fa fa-inbox fa-2x mb-2'></i>
                        <br />
                        {activeFiltersCount > 0 ? t('NoSearchResults') : t('لا توجد أوامر شراء')}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Loading>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />

      <NeatixModal
        show={showPurchaseRequest}
        setShow={setShowPurchaseRequest}
        bodyClassName='p-0'
        size='xl'
        showHeader={false}
      >
        <PurchaseRequestList Route='PurchaseOrder' />
      </NeatixModal>

      <NeatixModal
        show={showPurchaseQuotation}
        setShow={setShowPurchaseQuotation}
        bodyClassName='p-0'
        size='lg'
        showHeader={false}
      >
        <PurchaseQuotationList Route='PurchaseOrder' />
      </NeatixModal>
    </>
  );
};

export default Index;
